export default __webpack_public_path__ + "static/media/quiz-img.0126bce6.jpeg";